import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button } from 'antd';
import React from 'react';


export interface IFinishExecutionProps {
  start: any;
  finish: any;
  onFinishClick: Function;
  sending: boolean;
  onUpdateNotification?: any;
}

interface IFinishExecutionState {
  hours: number;
  minutes: number;
  seconds: number;
}
export default class FinishExecution extends React.Component<IFinishExecutionProps, IFinishExecutionState> {
  constructor(props: IFinishExecutionProps) {
    super(props);

    this.handleFinish = this.handleFinish.bind(this)
  }

  async handleFinish () {
    await this.props.onFinishClick()
    this.props.onUpdateNotification()
  }

  render() {
    //const { onFinishClick } = this.props;
    return (
      <Wrapper>
        <div className='card'>
          <div className='summary-style' >
          <div ><FontAwesomeIcon style={{marginTop: '1rem'}}size={'3x'} icon={'check'} /></div>  
            <h2 style={{ marginTop: '4rem', fontWeight: 'bold', fontSize: '24px' }} >{I18n.l("ticket.execution.processFinish")}</h2>
            <p style={{ fontSize: '20px'}} >
            </p>
          </div>
        </div>
        
        <Button
          className={`button-style`}
          onClick={this.handleFinish}
          type='primary'
          loading={this.props.sending ? true : false}
        >
          {this.props.sending ? I18n.l("common.sending"): I18n.l("common.send")}
        </Button>
      </Wrapper>
    );
  }
}


const Wrapper = styled.div`
width: 50%;
margin-left : 25%;
.card{
  width: 100%;
  position: relative;
  height: 25vh;
  padding-top: 25px;
  padding-bottom: 25px;
  background: ${Theme.secondary.supahLightGrey};
  border-radius: 5px;
  margin-top: 1rem;
  box-shadow: 3px 5px 25px -5px ${Theme.secondary.midGrey};
  margin-bottom: 1rem;
}
.title-style {
  font-weight: bold;
  font-size: 22px;
  color :  ${Theme.secondary.midGrey};
}
.summary-style {
  position: relative;
  margin-top: 1rem;
}
.summary-style h2 {
  margin: 0;
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%) ;
}
.summary-style div {
  margin-top: 1rem;
  margin: 0;
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%) ;
}

.summary-style p {
  margin: 0;
  margin-top: 5rem;
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%) ;
}

.button-style {
  text-transform: uppercase;
  margin-top: 1.5rem;
  min-width: 115px;
  font-weight: bold;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%) ;
}

`